import styles from './create-new-price-dialog.module.scss';
import { Col, Row } from 'reactstrap';
import { Dialog, DialogActions, DialogContent, DialogTitle, GrayOutlinedButton, LoadingButton, SnackBarContext, TextField } from '@frontend-workspace/react-shared-lib';
import { useContext, useState } from 'react';
import { makeCourseRequest } from '../../../../requestUtils';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface CreateNewPriceDialogProps {
  onClose: () => void,
  open: boolean,
  refreshData: () => void
}

export function CreateNewPriceDialog(props: CreateNewPriceDialogProps) {
  const { t } = useTranslation();
  const { setSnackbarMessage } = useContext(SnackBarContext);
  const [loading, setLoading] = useState<boolean>(false);
  const [price, setPrice] = useState<string>("");

  const handlePriceChange = (event: any) => setPrice(event.target.value);

  const missingFields = (): boolean => {
    const requiredFieldsFilled =
      price;
    return requiredFieldsFilled ? false : true;
  };

  const handleAddPrice = () => {
    setLoading(true);
    const body = {
      value: price
    }
    makeCourseRequest(`resource/price/upsert`, 'POST', body).then(result => {
      setSnackbarMessage({ content: t('createNewPrice.addedPriceToList'), type: "info", });
      setLoading(false);
      props.refreshData();
      props.onClose();
    }).catch(() => setSnackbarMessage({ content: t('createNewPrice.couldNotAddPriceToList'), type: "error" }));
  };

  return (
    <Dialog
      open={props.open}
      maxWidth="xs"
      fullWidth>
      <DialogTitle className='mb-4'>
        {t('standard.newPrice')}
      </DialogTitle>
      <DialogContent>
        <Row>
          <Col xl={6}>
            <div className='mb-3'>
              <TextField
                label={<span>{t('standard.price')} &#42;</span>}
                name='price'
                fullWidth
                sx={{ minWidth: 150 }}
                value={price || ''}
                onChange={handlePriceChange}
                helperText={`${t('createNewPrice.priceFormat')}: 10450`}
              />
            </div>
          </Col>
        </Row>
      </DialogContent>
      <DialogActions>
        <LoadingButton
          variant="contained"
          size='large'
          onClick={handleAddPrice}
          disabled={loading || missingFields()}
          loading={loading}
          className='minButtonWidth'>
          {loading ? '' : t('createNewPrice.addPrice')}
        </LoadingButton>
        <GrayOutlinedButton
          variant="outlined"
          size='large'
          onClick={props.onClose}
          className='minButtonWidth'>
          {t('standard.cancel')}
        </GrayOutlinedButton>
      </DialogActions>
    </Dialog>
  );
}

export default CreateNewPriceDialog;
